import { defineComponent as _defineComponent } from 'vue'
import { PropType, computed } from "@nuxtjs/composition-api";

import { useAmplitude, useConfig, useLinkService } from "@/composables";
import { useCreatorShop } from "@/store/creator-shop";


export default /*#__PURE__*/_defineComponent({
  __name: 'CreatorShopProductTile',
  props: {
  productId: { type: String, required: true },
  title: { type: String, required: true },
  subtitle: { type: String, required: true },
  imageUrl: { type: String, required: true },
  href: { type: String, default: "" },
  to: { type: [String, Object], default: "" },
  width: { type: [String, Number], default: "100%" },
  height: { type: [String, Number], default: "100%" },
  aspect: { type: [String, Number], default: 1 },
  disabled: { type: Boolean, default: false },
  amplitudePayload: { type: Object as PropType<LtkProductProps>, required: true },
  position: { type: Number, required: false, default: null },
  isSearch: { type: Boolean, default: false },
},
  setup(__props) {

const props = __props;



const amplitude = useAmplitude();
const config = useConfig();
const linkService = useLinkService();

const onClick = () => {
  useCreatorShop().setReferringShopTab();
  if (props.isSearch) {
    amplitude?.sendEvent("/search/tap", {
      "click-position": props.position + 1,
      "content-id": props.productId,
      "content-type": "product",
      index: `${config.env}-ltk-shop-products`,
      "referring-component": "creator shop product feed",
      "search-experience": "matching-products-search",
    });
  }
  amplitude?.sendExitEvent("/product-browser", props.amplitudePayload);
};

const imageOptimized = computed(() => {
  return linkService.getImageLink({
    url: props.imageUrl,
    width: `${props.width}`,
    height: `${props.width}`,
    crop: false,
  });
});

return { __sfc: true,props, amplitude, config, linkService, onClick, imageOptimized }
}

})